import React, { useState, useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import Gantt, {
  Tasks,
  Dependencies,
  Resources,
  ResourceAssignments,
  Column,
  Editing,
  Toolbar,
  Item,
  Validation,
} from "devextreme-react/gantt";
import axios from "axios";
import { API_ROUTE, headersRequest } from "../helpers";
/* import moment from "moment"; */
import { v4 as uuidv4 } from "uuid";
import _ from "lodash";

require("devexpress-gantt/dist/dx-gantt.min.css");

const GanttScheduleRO = (props) => {
  const [tasks, setTasks] = useState([]);
  const [dependencies, setDependencies] = useState([]);
  const [resourceAssignments, setResourceAssignments] = useState([]);
  const selectedTask = useRef(null);
  const excludedDates = useRef([]);
  const companyResources = useRef([]);

  const getGanttData = () => {
    let getTasks = new Promise((resolve, rej) => {
      axios
        .get(`${API_ROUTE}schedule-tasks/${props.uid}`, headersRequest())
        .then((res) => {
          let processed = res.data.map((task) => {
            return {
              ...task,
              start: new Date(task.start),
              end: new Date(task.end),
              parentId: !task.parentId ? 0 : task.parentId,
            };
          });
          resolve(processed);
        });
    });
    let getDependencies = new Promise((resolve, rej) => {
      axios
        .get(
          `${API_ROUTE}schedule-tasks-dependencies/${props.uid}`,
          headersRequest()
        )
        .then((res) => {
          resolve(res.data);
        });
    });
    let getAssignments = new Promise((resolve, rej) => {
      axios
        .get(
          `${API_ROUTE}schedule-tasks-resources-assignments/${props.uid}`,
          headersRequest()
        )
        .then((res) => {
          resolve(res.data);
        });
    });
    let getExcludedDates = new Promise((resolve, rej) => {
      axios.get(`${API_ROUTE}excluded-dates`, headersRequest()).then((res) => {
        resolve(res.data);
      });
    });
    let getResources = new Promise((resolve, rej) => {
      axios
        .get(`${API_ROUTE}company-resources`, headersRequest())
        .then((res) => {
          resolve(res.data);
        });
    });
    Promise.all([
      getTasks,
      getDependencies,
      getAssignments,
      getExcludedDates,
      getResources,
    ]).then((values) => {
      excludedDates.current = values[3];
      companyResources.current = values[4];
      ReactDOM.unstable_batchedUpdates(() => {
        setTasks(values[0]);
        setDependencies(values[1]);
        let uniq_resources_assignments = values[2]?.map((item)=> {
          return {
            resourceId : item.resourceId,
            taskId : item.taskId
          }
        })
        let arrayForResourcesAssignments = _.unionWith(uniq_resources_assignments,_.isEqual)?.map((item,idx)=>{
          return {
            id : idx,
            resourceId : item.resourceId,
            taskId : item.taskId
          }
        })
        setResourceAssignments(arrayForResourcesAssignments)
      });
    });
  };

  const addTask = (task) => {
    task.values.projectUID = props.uid;
    task.values.key = task.key;
    axios
      .post(`${API_ROUTE}schedule-tasks`, task.values, headersRequest())
      .then(() => {
      })
      .catch((err) => {
        alert("error al crear la actividad, por favor refresca la página");
      });
  };

  const deleteTask = (task) => {
    axios
      .delete(`${API_ROUTE}schedule-tasks/${task.key}`, headersRequest())
      .catch((err) => {
        alert("error al eliminar la actividad, por favor refresca la página");
      });
  };

  const updateTask = (task) => {
    let taskUpdates = tasks.filter((item) => item.id === task.key)[0];
    if (taskUpdates.start > taskUpdates.end) {
      return;
    }
    axios
      .put(
        `${API_ROUTE}schedule-tasks/${task.key}`,
        taskUpdates,
        headersRequest()
      )
      .catch((err) => {
        alert("error al actualizar la actividad, por favor refresca la página");
      });
  };

  const addDependecy = (dependency) => {
    axios
      .post(
        `${API_ROUTE}schedule-tasks-dependencies/${props.uid}`,
        dependency.values,
        headersRequest()
      )
      .catch((err) => {
        alert("error al crear la relación, por favor refresca la página");
      });
  };

  const deleteDependecy = (task) => {
    axios
      .delete(
        `${API_ROUTE}schedule-tasks-dependencies/${task.values.predecessorId}/${task.values.successorId}/${props.uid}`,
        headersRequest()
      )
      .catch((err) => {
        alert("error al eliminar la relación, por favor refresca la página");
      });
  };

  const customCommand = (command) => {
    if (command.name === "addAbove" || command.name === "addBelow") {
      if (selectedTask.current) {
        let dummie = [...tasks];
        let pos = tasks.findIndex(
          (task) => task.id === selectedTask.current.id
        );

        if (command.name === "addBelow") {
          pos++;
        }

        let task = {
          id: uuidv4(),
          title:
            command.name === "addBelow"
              ? "Nueva Tarea Abajo"
              : "Nueva Tarea Arriba",
          parentId: selectedTask.current.parentId || 0,
          start: new Date(selectedTask.current.start),
          end: new Date(selectedTask.current.end),
        };

        let taskToSave = {
          ...task,
          projectUID: props.uid,
          key: task.id,
        };

        axios
          .post(`${API_ROUTE}schedule-tasks`, taskToSave, headersRequest())
          .then(() => {
            dummie.splice(pos, 0, task);
            updateTasksIndex(dummie);
            setTasks([...dummie]);
          })
          .catch((err) => {
            alert("error al crear la actividad, por favor refresca la página");
          });
      } else {
        alert("Selecciona una actividad");
      }
    }
  };

  const updateTasksIndex = (tasks) => {
    axios
      .put(
        `${API_ROUTE}schedule-tasks-index/${props.uid}`,
        tasks,
        headersRequest()
      )
  };

  const addResource = (resource) => {
    axios
      .post(
        `${API_ROUTE}schedule-tasks-resources-assignments/${props.uid}`,
        resource.values,
        headersRequest()
      )
      .catch((err) => {
        alert("error al asignar el recurso, por favor refresca la página");
      });
  };

  const deleteResource = (resource) => {
    axios
      .delete(
        `${API_ROUTE}schedule-tasks-resources-assignments/${props.uid}/${resource.values.resourceId}/${resource.values.taskId}`,
        headersRequest()
      )
      .catch((err) => {
        alert("error al eliminar el recurso, por favor refresca la página");
      });
  };

  useEffect(() => {
    getGanttData();
  }, []);

  return (
    <>
      <Gantt
        taskListWidth={400}
        scaleType="months"
        height={400}
        onTaskInserting={(task) => {
          task.values.title = "Nueva Tarea " + (tasks.length + 1);
          task.values.progress = 0;
        }}
        onTaskInserted={addTask}
        onTaskUpdated={updateTask}
        onTaskDeleting={deleteTask}
        onDependencyInserted={addDependecy}
        onDependencyDeleted={deleteDependecy}
        validation={{ validateDependencies: true, autoUpdateParentTasks: true }}
        onCustomCommand={customCommand}
        firstDayOfWeek={1}
        onResourceAssigned={addResource}
        onResourceUnassigned={deleteResource}
      >
        <Tasks dataSource={tasks} />
        <Dependencies dataSource={dependencies} />
        <Resources dataSource={companyResources.current} />
        <ResourceAssignments dataSource={resourceAssignments} />

        <Toolbar>
          <Item name="collapseAll" />
          <Item name="expandAll" />
          <Item name="separator" />
          <Item name="zoomIn" />
          <Item name="zoomOut" />
        </Toolbar>
        <Column dataField="title" caption="Actividad" />
        <Column dataField="start" caption="Inicio" />
        <Column dataField="end" caption="Fin" />

        <Validation autoUpdateParentTasks={true} />
        <Editing enabled={false} />
      </Gantt>
    </>
  );
};

export default React.memo(GanttScheduleRO);
